import {
  FORUM_GET_ARTICLES_REQUEST,
  FORUM_GET_ARTICLES_SUCCESS,
  FORUM_GET_ARTICLES_FAIL,
  FORUM_GET_CATEGORIES_REQUEST,
  FORUM_GET_CATEGORIES_SUCCESS,
  FORUM_GET_CATEGORIES_FAIL,
  FORUM_REMOVE_ARTICLE_REQUEST,
  FORUM_REMOVE_ARTICLE_SUCCESS,
  FORUM_REMOVE_ARTICLE_FAIL,
  FORUM_GET_ARTICLE_REQUEST,
  FORUM_GET_ARTICLE_SUCCESS,
  FORUM_GET_ARTICLE_FAIL,
  FORUM_EDIT_ARTICLE_REQUEST,
  FORUM_EDIT_ARTICLE_SUCCESS,
  FORUM_EDIT_ARTICLE_FAIL,
  FORUM_CREATE_ARTICLE_REQUEST,
  FORUM_CREATE_ARTICLE_SUCCESS,
  FORUM_CREATE_ARTICLE_FAIL
} from "../actions/forum";

const initialState = {
  getArticlesRequest: false,
  getArticleRequest: false,
  getAuthorsRequest: false,
  removeArticleRequest: false,
  getCategoriesRequest: false,
  categories: [],
  errorMsg: "",
  successMsg: "",
  errors: {},
  articles: [],
  authors: [],
  articlesPagination: {},
  selectedArticle: {},

  editArticleRequest: false,
  successBackMsg: "",
  selectedArticles: []
};

const forum = (state = initialState, action) => {
  switch (action.type) {
    case FORUM_GET_ARTICLES_REQUEST:
      return {
        ...state,
        getArticlesRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {}
      };
    case FORUM_GET_ARTICLES_SUCCESS:
      return {
        ...state,
        getArticlesRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        articles: action.data.data,
        articlesPagination: {
          currentPage: action.data.current_page,
          lastPage: action.data.last_page
        }
      };
    case FORUM_GET_ARTICLES_FAIL:
      return {
        ...state,
        getArticlesRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors
      };
    case FORUM_GET_CATEGORIES_REQUEST:
      return {
        ...state,
        getCategoriesRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {}
      };
    case FORUM_GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        getCategoriesRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        categories: action.data
      };
    case FORUM_GET_CATEGORIES_FAIL:
      return {
        ...state,
        getCategoriesRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors
      };
    case FORUM_REMOVE_ARTICLE_REQUEST:
      return {
        ...state,
        removeUserRequest: true,
        errorMsg: "",
        successMsg: "",
        errors: {},
        selectedArticle: {}
      };
    case FORUM_REMOVE_ARTICLE_SUCCESS:
      return {
        ...state,
        removeUserRequest: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        selectedArticle: {}
      };
    case FORUM_REMOVE_ARTICLE_FAIL:
      return {
        ...state,
        removeUserRequest: false,
        errorMsg: action.msg,
        successMsg: "",
        errors: action.errors,
        selectedArticle: {}
      };
    case FORUM_GET_ARTICLE_REQUEST:
      return {
        ...state,
        getArticleRequest: true,
        successMsg: "",
        errorMsg: "",
        errors: {},
        selectedArticle: {}
      };
    case FORUM_GET_ARTICLE_SUCCESS:
      return {
        ...state,
        getArticleRequest: false,
        successMsg: "",
        errorMsg: "",
        errors: {},
        selectedArticle: action.data
      };
    case FORUM_GET_ARTICLE_FAIL:
      return {
        ...state,
        getArticleRequest: false,
        successMsg: "",
        errorMsg: action.msg,
        errors: action.errors,
        selectedArticle: {}
      };
    case FORUM_EDIT_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
        successBackMsg: "",
        errorMsg: "",
        errors: {}
      };
    case FORUM_EDIT_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: action.msg,
        errorMsg: "",
        errors: {}
      };
    case FORUM_EDIT_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: "",
        errorMsg: action.msg,
        errors: action.errors
      };
    case FORUM_CREATE_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
        successBackMsg: "",
        errorMsg: "",
        errors: {}
      };
    case FORUM_CREATE_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: action.msg,
        errorMsg: "",
        errors: {}
      };
    case FORUM_CREATE_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
        successBackMsg: "",
        errorMsg: action.msg,
        errors: action.errors
      };

    default:
      return state;
  }
};

export default forum;
